import { ListSubheader } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

import { AlertListItem } from './AlertListItem';
import { PortHealthAlertData } from './utils';

export interface AlertSectionProps {
  alerts: PortHealthAlertData[];
  label: string;
  icon: React.ComponentType<SvgIconProps>;
  bgcolor?: string;
}

export const AlertSection: React.FC<AlertSectionProps> = ({
  alerts,
  label,
  icon: Icon,
  bgcolor,
}) => {
  if (alerts.length === 0) return null;

  const content = (
    <>
      <ListSubheader
        style={{
          backgroundColor: 'transparent',
          color: 'white',
          fontWeight: 'bold',
          lineHeight: '32px',
        }}
      >
        {label} ({alerts.length})
      </ListSubheader>
      {alerts.map((alert) => (
        <AlertListItem
          key={alert.id}
          alert={alert}
          icon={<Icon style={{ color: 'white', fontSize: 25 }} />}
        />
      ))}
    </>
  );

  if (bgcolor) {
    return <div style={{ backgroundColor: bgcolor }}>{content}</div>;
  }

  return <>{content}</>;
};
